import { Modal } from '@platform/components';

export const TeamDiscoveryDecisionedModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const closeModal = () => {
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      url.searchParams.delete('decisioned');
      window.history.pushState({}, '', url.toString());
      onClose();
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      title='Thanks for letting us know'
      headerDivision='divider'
      variant='dialog'
      primaryCTA={{
        text: 'Close',
        callback: () => closeModal(),
      }}
      ignoreExtraPadding
    >
      <p>
        We've recorded your decision and closed this request. If your project no longer needs
        support, you can unpublish it at any time. If it remains published, we'll keep your
        organization in mind for future opportunities.
      </p>
    </Modal>
  );
};
